export default {
  downloadReport: 'DOWNLOAD_REPORT',
  downloadReportSuccess: 'DOWNLOAD_REPORT_SUCCESS',
  downloadReportFailed: 'DOWNLOAD_REPORT_FAILED',
};
